/**
 * The type of entity service
 */
export enum EntityServiceType {
  /**
   * Call the general Entity services number defined for the entity.
   */
  CallGeneralNumber = 'call-general-number',

  /**
   * Call a specific phone number defined for this entity service.
   */
  CallSpecificNumber = 'call-specific-number',
}
